import { usePagination as e } from "./usePagination.js";
import { useState as t } from "react";
//#region src/hooks/usePaginatedQuery.ts
function n(n, r, { pageSize: i, queryOptions: a } = {}) {
	let [o, s] = t(), c = e(o, i), l = n(c.queryWithPagination(r), a), u = l.data?.count;
	u !== o && s(u);
	let d = {
		total: u ?? 0,
		currentPage: c.currentPage,
		pageSize: c.pageSize,
		onPageChange: c.onPageChange
	};
	return {
		...l,
		...c,
		pager: d
	};
}
//#endregion
export { n as usePaginatedQuery };
